<template>
  <div :class="['form-item-box', { 'change-form-item-box-style': item.changeformItemBoxStyle }]">
    <label :for="item.field" class="form-item-subTitle" role="subtitle">{{
      i18n.t(item.label)
    }}</label>
    <span
      v-if="item.subLabel"
      class="sub-label"
      :style="{ marginLeft: item.field === 'birthday' ? '24px' : '4px' }"
    >
      <!--      {{ i18n.t(item.subLabel) }}-->
    </span>
    <div class="content">
      <div
        class="content-input-group"
        :style="{ 'margin-top': item.contentInputGroupMarginTop }"
        :key="item.field"
      >
        <img
          v-if="item.field === 'email' && item.emailIcon"
          class="email-logo"
          src="~img/email.png"
          alt="email logo"
        />
        <img
          v-if="item.field === 'password' && item.passwordIcon"
          class="password-logo"
          src="~img/lock.png"
          alt="password logo"
        />
        <input
          v-model="itemValue[`${item.field}`]"
          role="input"
          :autocomplete="item.type === 'text' ? 'off' : 'new-password'"
          :id="item.field"
          :key="item.field"
          :type="inputType(item)"
          :placeholder="getPlaceholder(item)"
          :maxlength="item.maxlength"
          :minlength="item.minlength"
          :class="[
            'form-item-input',
            'fs-mask',
            { 'form-item-error-border': item.errorShow },
            { 'come-from-PC-acoount': item.comeFormUserInfo },
          ]"
          :disabled="item.disabled"
          :draggable="item.field === 'birthday'"
          @input="handleValueChange($event, item.field)"
          @blur="handleValueSend($event, item.field)"
          @touchstart="handleInputFocus(item.field)"
          @click="handleInputFocus(item.field)"
          v-if="
            item.field === 'password' ||
            item.field === 'oldPassword' ||
            item.field === 'confirmPassword'
          "
        />
        <SafeInput
          v-else
          v-model="itemValue[`${item.field}`]"
          role="input"
          :autocomplete="item.type === 'text' ? 'off' : 'new-password'"
          :id="item.field"
          :type="inputType(item)"
          :placeholder="getPlaceholder(item)"
          :maxlength="item.maxlength"
          :minlength="item.minlength"
          :className="[
            'form-item-input',
            { 'form-item-error-border': item.errorShow },
            { 'come-from-PC-acoount': item.comeFormUserInfo },
          ]"
          :disabled="item.disabled"
          @input="handleValueChange($event, item.field)"
          @blur="handleValueSend($event, item.field)"
        />
        <img
          class="eye"
          v-show="
            item.field === 'password' ||
            item.field === 'confirmPassword' ||
            item.field === 'oldPassword' ||
            item.field === 'visaCardNum' ||
            item.field === 'visaCardName' ||
            item.leixing === 'userInfo' ||
            item.comeForm === 'SignUp2'
          "
          :src="inputIcon(item)"
          @click="typeStatus(item)"
          alt="hide password"
        />
      </div>
    </div>
    <p v-show="item.errorShow" class="form-item-error" :key="item.errorMsg">
      {{ item.errorMsg }}
    </p>
  </div>
</template>

<script>
  // 解决step1弹窗获取不到对应字段的问题
  import i18n from '@/i18n/index';
  import eyeOn from '@/assets/images/icon-feather-eye-on.svg';
  import eyeOff from '@/assets/images/icon-feather-eye-off.svg';
  import { formatCardNo, checkNumber } from '../Form/utils';
  import { getEmailBeforeAt } from '@/utils';
  import SafeInput from '@/components/SafeInput/index.vue';

  export default {
    name: 'FormInput',
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      itemFormValue: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      SafeInput,
    },
    mounted() {
      if (this.itemFormValue) {
        const isItem = Object.keys(this.itemFormValue);
        if (isItem?.length) {
          // TODO: 之后要再测一下step1弹窗的回填功能
          let visaCardNum = '';
          if (this.itemFormValue.visaCardNum) {
            visaCardNum = this.itemFormValue.visaCardNum
              ? { visaCardNum: formatCardNo(this.itemFormValue.visaCardNum) }
              : '';
          }
          this.itemValue = { ...this.itemValue, ...this.itemFormValue, ...visaCardNum };
          // 密文
          this.changeEmail = getEmailBeforeAt(this.itemValue.email);
          // 明文
          this.originEmail = this.itemValue.email;
          this.itemValue.email = this.changeEmail;
        }
      }
    },

    data() {
      return {
        i18n,
        itemValue: {},
        eyeImgOff: eyeOff,
        eyeImgOn: eyeOn,
        oldDateNum: '',
        // TODO: 处理input填充问题
        inputReadonly: {
          password: true,
          confirmPassword: true,
          oldPassword: true,
          visaCardNum: true,
          visaCardName: true,
          username: true,
          verificationCode: true,
          birthday: true,
          email: true,
          confirmEmail: true,
        },
        changeEmail: '',
        originEmail: '',
      };
    },

    methods: {
      getPlaceholder(item) {
        if (!item.placeholder) {
          return '';
        }
        const translated = i18n.t(item.placeholder);
        // 如果翻译结果与 key 相同，说明没有找到对应的翻译，此时返回 item.placeholder 原值
        // 或者如果 i18n.t 返回了 key 本身（这是 vue-i18n 的默认行为），我们也接受它作为 fallback
        return translated !== item.placeholder ? translated : item.placeholder;
      },
      inputIcon(item) {
        return item.icon === 'off' || item.icon === undefined || item.icon === null
          ? this.eyeImgOff
          : this.eyeImgOn;
      },
      inputType(item) {
        if (item.field !== 'email') {
          return item.type;
        }
        if (item.field === 'email' && item.comeForm === 'SignUp2') {
          return item.type;
        }
        return 'text';
      },
      typeStatus(item) {
        let iconValue,
          typeValue = '';
        if (item.field !== 'email' || (item.field === 'email' && item.comeForm === 'SignUp2')) {
          if (!item.icon) {
            iconValue = 'on';
          } else {
            iconValue = item.icon === 'off' ? 'on' : 'off';
          }
          typeValue = iconValue === 'on' ? 'text' : 'password';
          this.$set(item, 'icon', iconValue);
          this.$set(item, 'type', typeValue);
        }

        if (item.field === 'email' && item.comeForm !== 'SignUp2')
          this.$set(
            item,
            'icon',
            item.icon === 'off' || item.icon === undefined || item.icon === null ? 'on' : 'off',
          );
        console.log('item', item);
        if (item.icon === 'off' && item.field === 'email' && item.comeForm !== 'SignUp2') {
          return (this.itemValue.email = this.changeEmail);
        } else if (item.icon === 'on' && item.field === 'email' && item.comeForm !== 'SignUp2') {
          return (this.itemValue.email = this.originEmail);
        }
      },

      // 用户触发input时调用
      handleValueChange(e, field) {
        const { value } = e.target;
        let vsNum;

        // 判断是否存在空格，如果有则移除
        if (
          (field === 'email' ||
            field === 'confirmEmail' ||
            field === 'password' ||
            field === 'confirmPassword' ||
            field === 'oldPassword') &&
          value !== ''
        ) {
          const newValue = value.replace(/\s+/g, '');
          this.$set(this.itemValue, field, newValue);
        }

        if (field === 'visaCardNum' && value !== '') {
          const newValue = formatCardNo(value);
          this.$set(this.itemValue, field, newValue);

          // 实际要给到外面的值
          vsNum = { visaCardNum: value.replace(/\s+/g, '') };
        }

        if (field === 'birthday') {
          // 格式化生日日期格式 （不能在这里将日期格式转成yyyy-mm-dd，因为后面的整体校验拿的格式是dd/mm/yyyy这种格式校验的）
          this.formatBirthday(e, field);
        }

        this.$emit('change', { ...this.itemValue, ...vsNum }, field);
      },

      // 失去焦点后发送给父组件的数据
      handleValueSend(e, field) {
        // const { value } = e.target;
        let vsNum;
        // visaCardNum实际要给到外面的值
        if (field === 'visaCardNum' && this.itemValue[field]) {
          vsNum = { visaCardNum: this.itemValue[field].replace(/\s+/g, '') };
        }

        this.$emit('value', { ...this.itemValue, ...vsNum }, field);

        // TODO: 处理input填充问题
        this.inputReadonly[field] = true;
      },

      // 格式化生日日期格式
      formatBirthday(e, field) {
        let { value } = e.target;
        let bdNum1;
        let bdNum2;

        // TODO: 此处逻辑后面还需要再优化下
        if (field === 'birthday') {
          // 判断birthday当前的值是否为数字 + /
          this.$set(this.itemValue, field, value.replace(/[^\d|/]/g, ''));
          value = value.replace(/[^\d|/]/g, '');
        }

        let { length } = value;

        if (field === 'birthday') {
          // 当用户正在删除的情况下
          if (this.oldDateNum > length && length === 2) {
            value = value.slice(0, 1);
            this.$set(this.itemValue, field, value);
            const lg = value.length;
            length = lg;
          } else if (this.oldDateNum > length && length === 5) {
            value = value.slice(0, 4);
            this.$set(this.itemValue, field, value);
            const lg = value.length;
            length = lg;
          }

          if (length === 5) {
            const [n1, n2] = value.split('/');
            bdNum1 = n1;
            bdNum2 = n2;
          }

          if (length === 2 && checkNumber(value) && this.oldDateNum - length < 0) {
            this.$set(this.itemValue, field, `${value}/`);
          } else if (
            length === 5 &&
            checkNumber(bdNum1) &&
            checkNumber(bdNum2) &&
            this.oldDateNum - length < 0
          ) {
            this.$set(this.itemValue, field, `${value}/`);
          }
        }

        this.oldDateNum = length;
      },

      // TODO: 处理input填充问题
      handleInputFocus(field) {
        this.inputReadonly[field] = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @use './index';
  @use './mobile';
</style>
